(function () {
	'use strict';

	angular
		.module('invesfleet')
		.directive('loadingPane', loadingPane);
	

	function loadingPane() {
		return {
			restrict: 'EA',
			replace: true,
			transclude: true,
			scope: {
				loaded: '=loaded',
				message: '@?'
			},
			templateUrl: 'app/views/directives/loadingPane.html'
		};
		
	}
})();

